import { FunctionComponent } from 'react';

import useCompanySearchTable from './useCompanySearchTable';

import { Header, Rows, Visibility } from '../components';

const CompanySearchTable: FunctionComponent = function () {
  const { showTable, table, rows, onClick } = useCompanySearchTable();
  return (
    <div className="w-full max-w-full flex flex-col flex-1 overflow-x-scroll">
      {showTable ? (
        <>
          <Visibility
            table={table}
            columns={[{ id: 'cid', label: 'Toggle CID column visibility' }]}
          />
          <table className="mx-auto">
            <Header table={table} />
            <Rows rowModel={rows} onClick={onClick} />
          </table>
        </>
      ) : (
        <p className="m-auto text-16-20-em">No results</p>
      )}
    </div>
  );
};

export default CompanySearchTable;
